import React from 'react';
import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

// Added and exported RowSkeleton component
export function RowSkeleton() {
  return (
    <li className="flex items-center space-x-4 p-4">
      <div className="flex-shrink-0">
        <Skeleton className="size-5 rounded-full" />
      </div>
      <div className="flex-shrink-0">
        <Skeleton className="size-10 rounded-full" />
      </div>
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </li>
  );
}